export default __webpack_public_path__ + "static/media/logo-removebg-preview.a97e3bb9.png";